import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { StyledGrid } from '@Utils/styles';
import { DropDownButton, ZIndex, Text } from '@innovyze/stylovyze';
import { Button, Grid, Stack } from '@mui/material';

export const RangesButton = (
	isLoading: boolean,
	onSetRange: (ranges: number) => void,
	ranges: number,
) => {
	const { t } = useGlobalization();

	const rangeOptions = () => {
		const options = [];
		for (let i = 1; i <= 10; ++i) {
			options.push({
				onClick: () => {
					onSetRange(i);
				},
				name: t('{{ranges}} Ranges', { ranges: i + 2 }),
			});
		}
		return options;
	};

	return (
		<DropDownButton
			key={Date.now()}
			options={rangeOptions()}
			initialSelectedIndex={ranges - 1}
			color="primary"
			variant="outlined"
			fitMenuToContent
			fitButtonToContent
			disabled={isLoading}
			popupZIndex={ZIndex.DropDownButtonMenu}
		/>
	);
};

interface TableToolbarProps {
	name: string;
	isLoading: boolean;
	onSetRanges: (ranges: number) => void;
	onRecalculateCount: () => void;
	ranges: number;
}

export const TableToolbar = ({
	name,
	isLoading,
	onSetRanges,
	onRecalculateCount,
	ranges,
}: TableToolbarProps) => {
	const { t } = useGlobalization();
	return (
		<StyledGrid
			container
			style={{
				width: '100%',
				marginTop: '1rem',
				marginBottom: '1rem',
			}}>
			<Grid item xs={6}>
				<Text variant="heading-large-strong">
					{t('{{name}} Ranges', { name: name })}
				</Text>
				<Text variant="caption-medium">
					{t(
						'These are the ranges that will be used in your asset groups. You can change the number of ranges and edit their values in the table.',
					)}
				</Text>
			</Grid>
			<Grid item xs={6} display="flex" justifyContent="flex-end">
				<Stack direction={'row'} spacing={'20px'} alignItems={'center'}>
					<Button
						disabled={isLoading}
						variant="outlined"
						onClick={() => {
							onRecalculateCount();
						}}>
						{t('Recalculate Asset Count')}
					</Button>
					{RangesButton(isLoading, onSetRanges, ranges)}
				</Stack>
			</Grid>
		</StyledGrid>
	);
};
